<template>

    <div class="blockquote">
        <div class="blockquote_card">
            <div v-if="image" class="blockquote_card_image">
                <img :src="imgPath(image)"  />
            </div>
        </div>
        <div class="blockquote_content">
            <div v-if="quote" class="blockquote_content_quote" v-html="quote">
            </div>
            <div class="blockquote_content_name" v-html="name"></div>
            <div class="blockquote_content_title" v-html="title"></div>
        </div>
    </div>

</template>

<script>
    import ArticleSection from "./ArticleSection";
    export default {
        name: 'Quote',
        components: {ArticleSection},
        props: ['image', 'name', 'title', 'quote'],
        methods: {
            imgPath: function(image){
                return require('../assets/img/'+image);
            },
        },
    };
</script>

<style scoped lang="scss">
    .blockquote{
        display: flex;
        align-items: top;
        margin:$G-default 0;

        &_card {

            &_image{
                width: 10rem;
                min-width: 10rem;
                height: 10rem;
                object-fit: cover;
                margin-right: $G-default/1.2;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 10rem;
                }
            }
        }
         &_content{
            font-family: $F-Montserrat;
            font-size: 2rem;
            line-height: 1.5em;
            font-weight: $FW-semibold;

            &_title{
                font-size:1.3rem;
                line-height:1.5em;
                text-transform: uppercase;
            }

            &_name {
                font-size:1.5rem;
                line-height:1.5em;
                text-transform: uppercase;
            }

        
            &_quote{
                margin-bottom: $G-default/2;
                font-weight: $FW-light;
                font-size: 3rem;
            }
        }
    }
</style>